/** Search node names, categories and subcategories with the same matching rules. */
export function matchesBehaviorCatalogSearch(
  item: {
    label: string;
    categoryLabel?: string;
    subCategoryLabel?: string;
  },
  query: string,
): boolean {
  const normalize = (value: string) =>
    value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLocaleLowerCase();
  const searchableText = normalize(
    [item.label, item.categoryLabel, item.subCategoryLabel]
      .filter(Boolean)
      .join(" "),
  );
  return normalize(query)
    .trim()
    .split(/\s+/)
    .every((word) => searchableText.includes(word));
}
